<template>
	<div class="container gpBGcolor text-white" style="margin-top:100px">
		<div class="row well2 mb-4">
			<div class="col-sm-12 col-lg-6">
				<h1 v-if="!this.isSmall" class="text-uppercase text-center mt-3">{{this.gameName}}</h1>
				<img :src="this.screenshot" class="img-fluid d-block mx-auto mt-3"/>
			</div>
			<!-- :src="require(`../assets/screenshots/${this.gScreenshot}`)" -->
			<div class="col-sm-12 col-lg-6">
				<h1 v-if="this.isSmall" class="text-uppercase text-center mt-3">{{this.gameName}}</h1>
				<h1 v-else class="text-uppercase text-center mt-3">&nbsp;</h1>
				<div class="well p-4 mt-3 mb-3">
					<p v-html="this.description" class="text-justify mt-4"></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  props: ["data", "gamename"],
  data() {
    return {
      wsize: Number,
      isSmall: Boolean,
      gData: {}
    };
  },
  computed: {
    gameName: function() {
      return this.gData.gameName;
    },
    screenshot: function() {
      return "dist/" + this.gData.screenshot;
      //   return require(`../assets/screenshots/${this.gData.screenshot}`);
    },
    description: function() {
      return this.gData.description;
    }
  },
  watch: {
    $route(to, from) {
      //   console.log("DETAIL WATCHED::", this.$route.path);
      //   console.log("DETAIL TO::", to);
      //   console.log("DETAIL FROM::", from);

      //handle in-page route change ONLY, not to/from root
      if (to.path != "/" && from.path != "/") this.$router.go(to.fullPath);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      //   console.log("PATH::" + vm.$route.path);
      var fullname = vm.$route.path;
      fullname = fullname
        .substring(1)
        .split("-")
        .join(" ");
      var foo = vm.$gamedata.gamedata.data.find(element => {
        return element.gameName === fullname;
      });
      //   console.log(foo);
      vm.gData = foo; //vm.$gamedata.gamedata.data[idx];
      //   vm.gData = foo;
    });
  },
  created() {
    // console.log("DETAIL CREATED::" + this.$route.path);
    // var fullname = this.$route.path;
    // fullname = fullname
    //   .substring(1)
    //   .split("-")
    //   .join(" ");
    // var foo = this.$gamedata.gamedata.data.find(element => {
    //   return element.gameName === fullname;
    // });
    // this.gData = foo; //vm.$gamedata.gamedata.data[idx];

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wsize = window.innerWidth;
      this.isSmall = this.wsize < 992;
      //   console.log(this.isSmall);
    }
  }
};
</script>

<style scoped>
img {
  border: 2px solid rgb(39, 49, 71);
  border-radius: 5px;
}

.well {
  border-radius: 15px;
  border: 1px solid rgb(39, 49, 71);
  background-color: #172131;
}

.well2 {
  border-radius: 15px;
  border: 1px solid rgb(39, 49, 71);
  background-color: #080d16;
}

@media (max-width: 992px) {
  h1 {
    font-size: 1.8rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/GameDetail.vue